import React, { useState, useEffect, useRef } from 'react';
import {
  Drawer,
  TextField,
  Button,
  Grid,
  Typography,
  Box,
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  InputAdornment,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Paper,
  FormControlLabel,
  Switch,
  Divider,
  Tabs,
  Tab
} from '@mui/material';
import { CloudUpload, Delete } from '@mui/icons-material';

// Dane pakietów prac
const workPackages = [
  { stage: 'PRZYGOTOWANIE', name: 'Zasilanie elektryczne budowy', symbol: '1P-1' },
  { stage: 'PRZYGOTOWANIE', name: 'Ujęcie wody na budowę', symbol: '1P-2' },
  { stage: 'PRZYGOTOWANIE', name: 'Geodeta', symbol: '1P-3' },
  { stage: 'PRZYGOTOWANIE', name: 'Transport', symbol: '1P-4' },
  { stage: 'PRZYGOTOWANIE', name: 'Rozładunek', symbol: '1P-5' },
  { stage: 'STAN SUROWY', name: 'Roboty ziemne', symbol: '2S-1' },
  { stage: 'STAN SUROWY', name: 'Konstrukcje żelbetowe (fundamenty, murowanie ścian, stropy)', symbol: '2S-2' },
  { stage: 'STAN SUROWY', name: 'Konstrukcje stalowe (jako opcja)', symbol: '2S-3' },
  { stage: 'STAN SUROWY', name: 'Więźba dachowa', symbol: '2S-4' },
  { stage: 'STAN SUROWY', name: 'Poszycie dachowe', symbol: '2S-5' },
  { stage: 'STAN DEWELOPERSKI', name: 'Stolarka okienna zewnętrzna', symbol: '3D-1' },
  { stage: 'STAN DEWELOPERSKI', name: 'Drzwi zewnętrzne', symbol: '3D-2' },
  { stage: 'STAN DEWELOPERSKI', name: 'Brama garażowa', symbol: '3D-3' },
  { stage: 'STAN DEWELOPERSKI', name: 'Elewacja: metoda - lekka-mokra', symbol: '3D-4' },
  { stage: 'STAN DEWELOPERSKI', name: 'Elewacja Tynki renowacyjne', symbol: '3D-5' },
  { stage: 'STAN DEWELOPERSKI', name: 'Elewacja wentylowana', symbol: '3D-6' },
  { stage: 'STAN DEWELOPERSKI', name: 'Instalacje elektryczne wewnętrzne (gniazda, oświetlenie, teletechnika)', symbol: '3D-7' },
  { stage: 'STAN DEWELOPERSKI', name: 'Instalacja fotowoltaiki', symbol: '3D-8' },
  { stage: 'STAN DEWELOPERSKI', name: 'Wod-kan i c.o.', symbol: '3D-9' },
  { stage: 'STAN DEWELOPERSKI', name: 'Wentylacja mechaniczna z rekuperacją', symbol: '3D-10' },
  { stage: 'STAN DEWELOPERSKI', name: 'Klimatyzacja', symbol: '3D-11' },
  { stage: 'STAN DEWELOPERSKI', name: 'Posadzki', symbol: '3D-12' },
  { stage: 'STAN DEWELOPERSKI', name: 'Tynki', symbol: '3D-13' },
  { stage: 'STAN DEWELOPERSKI', name: 'Przyłącze elektryczne', symbol: '3D-14' },
  { stage: 'STAN DEWELOPERSKI', name: 'Przyłącze gazowe', symbol: '3D-15' },
  { stage: 'STAN DEWELOPERSKI', name: 'Przyłącze wod-kan', symbol: '3D-16' },
  { stage: 'STAN DEWELOPERSKI', name: 'Izolacje z wełny + suche zabudowy poddasza', symbol: '3D-17' },
  { stage: 'WYKOŃCZENIA WNĘTRZ', name: 'Suche zabudowy, gładzie gipsowe + malowanie ścian i sufitów', symbol: '4W-1' },
  { stage: 'WYKOŃCZENIA WNĘTRZ', name: 'Tapetowanie ścian', symbol: '4W-2' },
  { stage: 'WYKOŃCZENIA WNĘTRZ', name: 'Układanie gresów, terakoty, glazur', symbol: '4W-3' },
  { stage: 'WYKOŃCZENIA WNĘTRZ', name: 'Parkiet drewniany', symbol: '4W-4' },
  { stage: 'WYKOŃCZENIA WNĘTRZ', name: 'Wykładziny', symbol: '4W-5' },
  { stage: 'WYKOŃCZENIA WNĘTRZ', name: 'Posadzki specjalistyczne (np. mikrocement)', symbol: '4W-6' },
  { stage: 'WYKOŃCZENIA WNĘTRZ', name: 'Schody', symbol: '4W-7' },
  { stage: 'WYKOŃCZENIA WNĘTRZ', name: 'Balustrady drewniane', symbol: '4W-8' },
  { stage: 'WYKOŃCZENIA WNĘTRZ', name: 'Balustrady stalowe', symbol: '4W-9' },
  { stage: 'WYKOŃCZENIA WNĘTRZ', name: 'Balustrady szklane', symbol: '4W-10' },
  { stage: 'WYKOŃCZENIA WNĘTRZ', name: 'Stolarz (zabudowy kuchni, etc.)', symbol: '4W-11' },
  { stage: 'WYKOŃCZENIA WNĘTRZ', name: 'Drzwi wewnętrzne', symbol: '4W-12' },
  { stage: 'WYKOŃCZENIA WNĘTRZ', name: 'Parapety wewnętrzne', symbol: '4W-13' },
  { stage: 'WYKOŃCZENIA WNĘTRZ', name: 'Blaty kamienne/konglomeratowe', symbol: '4W-14' },
  { stage: 'WYKOŃCZENIA WNĘTRZ', name: 'Zabudowy szklane', symbol: '4W-15' },
  { stage: 'WYKOŃCZENIA WNĘTRZ', name: 'Zasłony, rolety, kurtyny', symbol: '4W-16' },
  { stage: 'ZAGOSPODAROWANIE TERENU', name: 'Ogrodzenie', symbol: '5Z-1' },
  { stage: 'ZAGOSPODAROWANIE TERENU', name: 'Podjazd, chodniki', symbol: '5Z-2' },
  { stage: 'ZAGOSPODAROWANIE TERENU', name: 'Zieleń, nasadzenia', symbol: '5Z-3' },
  { stage: 'ZABYTKI', name: 'Polichromie', symbol: '6K-1' },
  { stage: 'ZABYTKI', name: 'Rzeźba', symbol: '6K-2' },
  { stage: 'ZABYTKI', name: 'Kamieniarstwo', symbol: '6K-3' },
  { stage: 'ZABYTKI', name: 'Stolarstwo', symbol: '6K-4' },
  { stage: 'ZABYTKI', name: 'Sztukaterie', symbol: '6K-5' },
  { stage: 'PROJEKTOWANIE', name: 'Architektura', symbol: '7PR-1' },
  { stage: 'PROJEKTOWANIE', name: 'Konstrukcja', symbol: '7PR-2' },
  { stage: 'PROJEKTOWANIE', name: 'Instalacje elektryczne', symbol: '7PR-3' },
  { stage: 'PROJEKTOWANIE', name: 'Instalacje teletechniczne (SSP, KD, SSWiN, Sieci strukturalne)', symbol: '7PR-4' },
  { stage: 'PROJEKTOWANIE', name: 'Instalacje sanitarne', symbol: '7PR-5' }
];

// Lista unikalnych etapów
const stages = Array.from(new Set(workPackages.map(pkg => pkg.stage)));

interface AddPackageFormProps {
  open: boolean;
  onClose: () => void;
  onAdd: (packageData: any, files?: File[]) => void;
  onEdit?: (packageData: any, files?: File[]) => void;
  onDelete?: (packageSymbol: string) => void;
  editMode?: boolean;
  packageData?: any;
  importedFilePaths?: string[]; // ścieżki z JSON do uploadu po stronie backendu
}

const AddPackageForm: React.FC<AddPackageFormProps> = ({
  open,
  onClose,
  onAdd,
  onEdit,
  onDelete,
  editMode = false,
  packageData = null,
  importedFilePaths = []
}) => {
  const [selectedStage, setSelectedStage] = useState<string>('');
  const [selectedPackage, setSelectedPackage] = useState<any>(null);
  const [packageType, setPackageType] = useState<string>(''); // Nowy stan dla rodzaju pakietu
  const [formData, setFormData] = useState({
    description: '',
    parameters: '',
    estimatedValue: ''
  });
  const [useCustomWorkType, setUseCustomWorkType] = useState<boolean>(false);
  const [customWorkName, setCustomWorkName] = useState<string>('');
  const [customWorkSymbol, setCustomWorkSymbol] = useState<string>('');
  
  const [files, setFiles] = useState<File[]>([]);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const dirInputRef = useRef<HTMLInputElement>(null);
  const [folderPickSummary, setFolderPickSummary] = useState<string>('');
  const [packageTabValue, setPackageTabValue] = useState(0); // Podzakładki: 0=Wybór pakietu prac, 1=Dokumentacja, 2=Szczegóły pakietu

  // Filtrowanie pakietów na podstawie wybranego etapu
  const filteredPackages = selectedStage 
    ? workPackages.filter(pkg => pkg.stage === selectedStage) 
    : [];

  // Wypełnij formularz danymi pakietu, jeśli przekazano packageData (zarówno import JSON jak i tryb edycji)
  useEffect(() => {
    if (packageData) {
      const foundPackage = workPackages.find(pkg => pkg.symbol === packageData.symbol);
      if (foundPackage) {
        setSelectedStage(foundPackage.stage);
        setSelectedPackage(foundPackage);
      }
      setPackageType(packageData.package_type || packageData.packageType || ''); // Ustawienie rodzaju pakietu
      setFormData({
        description: packageData.description || '',
        parameters: packageData.parameters || '',
        estimatedValue: packageData.estimatedValue || ''
      });
      setUseCustomWorkType(false);
      setCustomWorkName('');
      setCustomWorkSymbol('');
    } else {
      // Reset formularza w trybie dodawania
      setSelectedStage('');
      setSelectedPackage(null);
      setPackageType(''); // Reset rodzaju pakietu
      setFormData({
        description: '',
        parameters: '',
        estimatedValue: ''
      });
      setFiles([]);
      setUseCustomWorkType(false);
      setCustomWorkName('');
      setCustomWorkSymbol('');
      setPackageTabValue(0);
    }
  }, [editMode, packageData, open]);

  const handleStageChange = (event: SelectChangeEvent) => {
    setSelectedStage(event.target.value);
    setSelectedPackage(null);
  };

  const handlePackageTypeChange = (event: SelectChangeEvent) => {
    setPackageType(event.target.value);
  };

  const handlePackageChange = (event: React.SyntheticEvent, value: any) => {
    setSelectedPackage(value);
  };

  const handleToggleCustom = (event: React.ChangeEvent<HTMLInputElement>) => {
    const next = event.target.checked;
    setUseCustomWorkType(next);
    if (next) {
      setSelectedPackage(null);
    } else {
      setCustomWorkName('');
      setCustomWorkSymbol('');
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = () => {
    // Walidacja minimalna:
    // - w trybie dodawania wymagamy wyboru z listy lub własnego rodzaju prac
    // - w trybie edycji pozwalamy zapisać nawet gdy "Rodzaj robót" nie pasuje do listy (np. pakiety AI / niestandardowe)
    if (!editMode) {
      if (!useCustomWorkType && !selectedPackage) return;
      if (useCustomWorkType) {
        if (!selectedStage || !customWorkName.trim()) return;
      }
    } else {
      if (useCustomWorkType) {
        if (!selectedStage || !customWorkName.trim()) return;
      } else {
        const fallbackName = (packageData?.name || '').trim();
        if (!selectedPackage && !fallbackName) return;
      }
    }

    // Przygotowanie danych pakietu
    const symbolFromCustom = customWorkSymbol && customWorkSymbol.trim()
      ? customWorkSymbol.trim()
      : (customWorkName.trim().slice(0, 5) || 'PAK');

    const baseSymbol = useCustomWorkType
      ? symbolFromCustom
      : (selectedPackage?.symbol || packageData?.symbol || packageData?.package_symbol || '');
    const baseName = useCustomWorkType
      ? customWorkName.trim()
      : (selectedPackage?.name || packageData?.name || '');
    const baseStage = useCustomWorkType
      ? selectedStage
      : (selectedPackage?.stage || packageData?.stage || selectedStage || '');

    const packageToSave: any = {
      symbol: baseSymbol,
      name: baseName,
      stage: baseStage,
      package_type: packageType, // snake_case
      description: formData.description,
      parameters: formData.parameters && formData.parameters.trim() ? formData.parameters.trim() : null,
      estimatedValue: formData.estimatedValue
    };
    
    // Dodaj linki tylko w trybie dodawania, w trybie edycji nie przesyłamy ich,
    // aby backend zachował istniejące wartości
    if (!editMode) {
      // Pola linków są puste, backend je uzupełni automatycznie przy tworzeniu nowego pakietu
      packageToSave.documentationLink = '';
      packageToSave.packageDocumentationLink = '';
    }

    // Przekazujemy pliki jako osobny parametr
    const filesToUpload = files.length > 0 ? files : undefined;

    if (editMode && onEdit) {
      onEdit(packageToSave, filesToUpload);
    } else {
      // Jeśli nie wybrano plików ręcznie, ale mamy ścieżki z importu JSON – przekażmy je do backendu
      if (!filesToUpload && importedFilePaths && importedFilePaths.length > 0) {
        onAdd({ ...packageToSave, files_paths: importedFilePaths }, undefined);
      } else {
        onAdd(packageToSave, filesToUpload);
      }
    }
    
    onClose();
  };

  // Pobranie wszystkich plików z wybranego folderu przez File System Access API
  const collectFilesFromDirectoryHandle = async (dirHandle: any): Promise<File[]> => {
    const out: File[] = [];
    // @ts-ignore – entries() dostępne w FSA API
    for await (const entry of dirHandle.values ? dirHandle.values() : dirHandle.entries()) {
      const handle = entry.kind ? entry : entry[1];
      if (handle.kind === 'file') {
        const file = await handle.getFile();
        out.push(file);
      } else if (handle.kind === 'directory') {
        const nested = await collectFilesFromDirectoryHandle(handle);
        out.push(...nested);
      }
    }
    return out;
  };

  const basename = (p: string) => (p || '').split('/').pop() || (p || '').split('\\').pop() || p;

  const mapFilesAgainstJsonList = (picked: File[]): File[] => {
    if (!importedFilePaths || importedFilePaths.length === 0) return picked;
    const expected = new Set(importedFilePaths.map(p => basename(p).toLowerCase()));
    const matched: File[] = [];
    const unmatched: File[] = [];
    picked.forEach(f => (expected.has(f.name.toLowerCase()) ? matched : unmatched).push(f));
    setFolderPickSummary(
      `Dopasowano ${matched.length}/${importedFilePaths.length} z listy JSON. ` +
      (unmatched.length ? `+ ${unmatched.length} innych plików.` : '')
    );
    return matched.length > 0 ? matched : picked;
  };

  const handlePickFolder = async () => {
    try {
      // Nowoczesny Chrome/Edge
      // @ts-ignore
      if (window.showDirectoryPicker) {
        // @ts-ignore
        const dirHandle = await window.showDirectoryPicker();
        const picked = await collectFilesFromDirectoryHandle(dirHandle);
        const next = mapFilesAgainstJsonList(picked);
        setFiles(next);
        return;
      }
    } catch (e) {
      console.warn('Wybór folderu (FSA API) przerwany/odrzucony:', (e as any)?.message);
      return;
    }
    // Fallback: input webkitdirectory
    if (dirInputRef.current) {
      dirInputRef.current.click();
    }
  };

  const handleDelete = () => {
    if (editMode && onDelete && packageData) {
      onDelete(packageData.symbol);
      onClose();
    }
  };

  // Spójne style pól formularza zgodne z makietą
  const textFieldSx = {
    '& .MuiInputLabel-root': {
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '16px',
      color: '#2D2D32'
    },
    '& .MuiOutlinedInput-root': {
      height: 32,
      backgroundColor: '#fff',
      borderRadius: '4px'
    },
    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d4d4d9' },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#595966' },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#2020AF !important' },
    '& .MuiOutlinedInput-root.Mui-focused': { boxShadow: 'none', outline: 'none' },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': { borderColor: '#d4d4d9' },
    '& .MuiOutlinedInput-root.Mui-error:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#595966' },
    '& .MuiOutlinedInput-root.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#2020AF !important' },
    '& .MuiInputBase-input': {
      padding: '8px 12px',
      boxSizing: 'border-box',
      fontFamily: 'Roboto, sans-serif',
      fontSize: '16px',
      color: '#2D2D32'
    },
    '& .MuiFormHelperText-root': { ml: 0 }
  } as const;

  const selectSx = {
    '& .MuiOutlinedInput-root': {
      height: 32,
      backgroundColor: '#fff',
      borderRadius: '4px'
    },
    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d4d4d9' },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#595966' },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#2020AF !important' },
    '& .MuiOutlinedInput-root.Mui-focused': { boxShadow: 'none', outline: 'none' },
    '&:has(.MuiSelect-root[aria-expanded="true"]) .MuiOutlinedInput-notchedOutline': { borderColor: '#2020AF !important' },
    '& .MuiSelect-select': {
      padding: '8px 12px',
      boxSizing: 'border-box',
      fontFamily: 'Roboto, sans-serif',
      fontSize: '16px',
      color: '#2D2D32'
    }
  } as const;

  const FieldLabel: React.FC<{ text: string; required?: boolean }> = ({ text, required }) => (
    <Typography sx={{ fontFamily: 'Roboto, sans-serif', fontWeight: 400, fontSize: '14px', lineHeight: '20px', color: '#2D2D32', mb: 0.5 }}>
      {text}
      {required && <Box component="span" sx={{ color: '#d32f2f' }}> *</Box>}
    </Typography>
  );

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: 680, maxWidth: '100vw', borderRadius: 0 } }}
    >
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ pl: 4, pr: 4, pt: '22px', pb: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h6" sx={{ fontFamily: 'Roboto, sans-serif', fontWeight: 500, fontSize: '18px', color: '#2D2D32' }}>
            {editMode ? 'Edytuj pakiet prac' : 'Dodaj nowy pakiet prac'}
          </Typography>
          <IconButton 
            onClick={onClose} 
            size="small"
            sx={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: 30,
              minHeight: 30,
              '& > *': {
                pointerEvents: 'none',
              },
            }}
          >
            <Box 
              component="img" 
              src="/assets/close.svg" 
              alt="Zamknij" 
              sx={{ 
                width: 13, 
                height: 13, 
                display: 'block',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                pointerEvents: 'none',
              }} 
            />
          </IconButton>
        </Box>
        <Box sx={{ p: 4, pt: 3, flex: 1, overflowY: 'auto' }}>
          <Box sx={{ mb: 3 }}>
            <Tabs 
              value={packageTabValue} 
              onChange={(e, newValue) => setPackageTabValue(newValue)} 
              variant="standard"
              sx={{ 
                position: 'relative',
                '&::after': { content: '""', position: 'absolute', left: 0, right: 0, bottom: 0, height: '1px', bgcolor: '#EDEDED' },
                '& .MuiTabs-scroller': { pl: 0, ml: 0 },
                '& .MuiTabs-flexContainer': { justifyContent: 'space-between' }
              }}
              TabIndicatorProps={{ sx: { height: 2, bgcolor: '#000000' } }}
            >
              <Tab 
                label="Wybór pakietu prac" 
                sx={{ 
                  fontFamily: 'Roboto, sans-serif',
                  fontWeight: 400,
                  fontSize: '16px',
                  textTransform: 'none',
                  color: '#020242',
                  minWidth: 'auto',
                  maxWidth: 'none',
                  px: 0,
                  textAlign: 'left',
                  '&.Mui-selected': { fontWeight: 500, color: '#020242' }
                }} 
              />
              <Tab 
                label="Dokumentacja" 
                sx={{ 
                  fontFamily: 'Roboto, sans-serif',
                  fontWeight: 400,
                  fontSize: '16px',
                  textTransform: 'none',
                  color: '#020242',
                  minWidth: 'auto',
                  maxWidth: 'none',
                  px: 0,
                  textAlign: 'left',
                  '&.Mui-selected': { fontWeight: 500, color: '#020242' }
                }} 
              />
              <Tab 
                label="Szczegóły pakietu" 
                sx={{ 
                  fontFamily: 'Roboto, sans-serif',
                  fontWeight: 400,
                  fontSize: '16px',
                  textTransform: 'none',
                  color: '#020242',
                  minWidth: 'auto',
                  maxWidth: 'none',
                  px: 0,
                  textAlign: 'left',
                  '&.Mui-selected': { fontWeight: 500, color: '#020242' }
                }} 
              />
            </Tabs>
          </Box>
        {packageTabValue === 0 && (
        <Grid container rowSpacing={1.5} columnSpacing={3}>
          
          <Grid item xs={12} md={6}>
            <FieldLabel text="Etap" />
            <FormControl fullWidth size="small" sx={selectSx}>
              <Select
                value={selectedStage}
                onChange={handleStageChange}
                displayEmpty
                renderValue={(val) => (val ? String(val) : 'Wybierz z listy')}
                IconComponent={(iconProps: any) => (
                  <Box
                    component="img"
                    alt="dropdown"
                    src="/assets/icons/keyboard_arrow_down.svg"
                    {...iconProps}
                    sx={{ width: 18, height: 18, mr: '8px', pointerEvents: 'none' }}
                  />
                )}
                sx={{
                  '& .MuiSelect-select': {
                    color: selectedStage ? 'inherit' : '#B9B9B9'
                  },
                  '&[aria-expanded="true"]': {
                    '& + .MuiOutlinedInput-notchedOutline': { borderColor: '#2020AF !important' }
                  },
                  '&.Mui-expanded': {
                    '& + .MuiOutlinedInput-notchedOutline': { borderColor: '#2020AF !important' }
                  }
                }}
              >
                <MenuItem value="">
                  <em>Wybierz</em>
                </MenuItem>
                {stages.map((stage) => (
                  <MenuItem key={stage} value={stage}>{stage}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <FieldLabel text="Rodzaj robót" />
            <Autocomplete
              options={filteredPackages}
              getOptionLabel={(option) => `${option.symbol} - ${option.name}`}
              value={selectedPackage}
              onChange={handlePackageChange}
              disabled={!selectedStage || useCustomWorkType}
              renderInput={(params) => (
                <TextField 
                  {...params} 
                  size="small"
                  placeholder={selectedStage ? "Wybierz rodzaj robót" : "Najpierw wybierz etap"}
                  sx={{
                    ...textFieldSx,
                    '& .MuiInputBase-input': {
                      ...textFieldSx['& .MuiInputBase-input'],
                      color: selectedPackage ? '#2D2D32' : '#B9B9B9'
                    }
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <FormControlLabel
              control={<Switch checked={useCustomWorkType} onChange={handleToggleCustom} />}
              label={<Typography sx={{ fontFamily: 'Roboto, sans-serif', fontSize: '14px', color: '#2D2D32' }}>Własny rodzaj prac</Typography>}
            />
          </Grid>

          {useCustomWorkType && (
            <>
              <Grid item xs={12} md={6}>
                <FieldLabel text="Nazwa rodzaju prac" required />
                <TextField
                  fullWidth
                  value={customWorkName}
                  onChange={(e) => setCustomWorkName(e.target.value)}
                  size="small"
                  sx={textFieldSx}
                  placeholder="Wpisz nazwę"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FieldLabel text="Symbol (opcjonalnie)" />
                <TextField
                  fullWidth
                  value={customWorkSymbol}
                  onChange={(e) => setCustomWorkSymbol(e.target.value)}
                  size="small"
                  sx={textFieldSx}
                  placeholder="Wpisz symbol"
                  helperText="Jeśli puste, użyjemy 5 pierwszych znaków nazwy"
                />
              </Grid>
            </>
          )}

          <Grid item xs={12} md={6}>
            <FieldLabel text="Rodzaj" />
            <FormControl fullWidth size="small" sx={selectSx}>
              <Select
                value={packageType}
                onChange={handlePackageTypeChange}
                displayEmpty
                renderValue={(val) => (val ? String(val) : 'Wybierz z listy')}
                IconComponent={(iconProps: any) => (
                  <Box
                    component="img"
                    alt="dropdown"
                    src="/assets/icons/keyboard_arrow_down.svg"
                    {...iconProps}
                    sx={{ width: 18, height: 18, mr: '8px', pointerEvents: 'none' }}
                  />
                )}
                sx={{
                  '& .MuiSelect-select': {
                    color: packageType ? 'inherit' : '#B9B9B9'
                  },
                  '&[aria-expanded="true"]': {
                    '& + .MuiOutlinedInput-notchedOutline': { borderColor: '#2020AF !important' }
                  },
                  '&.Mui-expanded': {
                    '& + .MuiOutlinedInput-notchedOutline': { borderColor: '#2020AF !important' }
                  }
                }}
              >
                <MenuItem value="">
                  <em>Wybierz</em>
                </MenuItem>
                <MenuItem value="materiały">Materiały</MenuItem>
                <MenuItem value="usługi">Usługi</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        )}
        {packageTabValue === 1 && (
        <Grid container rowSpacing={1.5} columnSpacing={3}>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
              <input
                type="file"
                multiple
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={(e) => {
                  if (e.target.files) {
                    setFiles(Array.from(e.target.files));
                    setFolderPickSummary('');
                  }
                }}
              />
              {/* Fallback dla wyboru katalogu (Safari/Firefox) */}
              <input
                type="file"
                // @ts-ignore
                webkitdirectory="true"
                multiple
                ref={dirInputRef}
                style={{ display: 'none' }}
                onChange={(e) => {
                  if (e.target.files) {
                    const picked = Array.from(e.target.files);
                    const next = mapFilesAgainstJsonList(picked);
                    setFiles(next);
                  }
                }}
              />
              <Button
                variant="outlined"
                startIcon={<CloudUpload />}
                onClick={() => fileInputRef.current?.click()}
                sx={{
                  fontFamily: 'Roboto, sans-serif',
                  fontSize: '14px',
                  textTransform: 'none',
                  borderColor: '#d4d4d9',
                  color: '#2D2D32',
                  '&:hover': {
                    borderColor: '#595966',
                    backgroundColor: 'transparent'
                  }
                }}
              >
                Dodaj pliki
              </Button>
              <Button 
                variant="outlined" 
                onClick={handlePickFolder}
                sx={{
                  fontFamily: 'Roboto, sans-serif',
                  fontSize: '14px',
                  textTransform: 'none',
                  borderColor: '#d4d4d9',
                  color: '#2D2D32',
                  '&:hover': {
                    borderColor: '#595966',
                    backgroundColor: 'transparent'
                  }
                }}
              >
                Wybierz folder
              </Button>
              <Typography variant="body2" sx={{ ml: 1, fontFamily: 'Roboto, sans-serif', fontSize: '14px', color: '#595966' }}>
                {files.length > 0 ? `Wybrano ${files.length} ${files.length === 1 ? 'plik' : 'pliki'}` : 'Nie wybrano plików'}
              </Typography>
            </Box>
            {!!folderPickSummary && (
              <Typography variant="caption" sx={{ display: 'block', mb: 1, fontFamily: 'Roboto, sans-serif', fontSize: '12px', color: '#595966' }}>
                {folderPickSummary}
              </Typography>
            )}
            {/* Lista ścieżek zaimportowanych z JSON (informacyjnie) */}
            {importedFilePaths && importedFilePaths.length > 0 && (
              <Paper variant="outlined" sx={{ p: 1.5, mb: 2, borderColor: '#d4d4d9' }}>
                <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, fontFamily: 'Roboto, sans-serif', fontSize: '14px', color: '#2D2D32' }}>
                  Pliki z JSON (zostaną wgrane po zapisie):
                </Typography>
                <List dense>
                  {importedFilePaths.map((p, idx) => (
                    <ListItem key={`${p}-${idx}`} sx={{ py: 0.5 }}>
                      <ListItemText 
                        primary={<Typography sx={{ fontFamily: 'Roboto, sans-serif', fontSize: '14px', color: '#2D2D32' }}>{p.split('/').pop() || p}</Typography>}
                        secondary={<Typography sx={{ fontFamily: 'Roboto, sans-serif', fontSize: '12px', color: '#595966' }}>{p}</Typography>}
                      />
                    </ListItem>
                  ))}
                </List>
              </Paper>
            )}
            
            {files.length > 0 && (
              <Paper variant="outlined" sx={{ p: 1.5, mb: 2, borderColor: '#d4d4d9' }}>
                <List dense>
                  {files.map((file, index) => (
                    <ListItem key={index} sx={{ py: 0.5 }}>
                      <ListItemText 
                        primary={<Typography sx={{ fontFamily: 'Roboto, sans-serif', fontSize: '14px', color: '#2D2D32' }}>{file.name}</Typography>}
                        secondary={<Typography sx={{ fontFamily: 'Roboto, sans-serif', fontSize: '12px', color: '#595966' }}>{`${(file.size / 1024).toFixed(1)} KB`}</Typography>}
                      />
                      <ListItemSecondaryAction>
                        <IconButton 
                          edge="end" 
                          size="small"
                          onClick={() => {
                            const newFiles = [...files];
                            newFiles.splice(index, 1);
                            setFiles(newFiles);
                          }}
                          sx={{
                            color: '#595966',
                            '&:hover': {
                              color: '#2D2D32',
                              backgroundColor: 'rgba(0, 0, 0, 0.04)'
                            }
                          }}
                        >
                          <Delete fontSize="small" />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
              </Paper>
            )}
          </Grid>
        </Grid>
        )}
        {packageTabValue === 2 && (
        <Grid container rowSpacing={1.5} columnSpacing={3}>
          <Grid item xs={12}>
            <FieldLabel text="Opis" />
            <TextField
              fullWidth
              name="description"
              value={formData.description}
              onChange={handleChange}
              multiline
              minRows={10}
              maxRows={15}
              variant="outlined"
              size="small"
              placeholder="Wpisz opis"
              sx={{ 
                ...textFieldSx, 
                '& .MuiOutlinedInput-root': { height: 'auto', backgroundColor: '#fff', borderRadius: '4px', alignItems: 'flex-start' },
                '& .MuiInputBase-input': { padding: 0 },
                '& .MuiOutlinedInput-input': { padding: 0 }
              }}
            />
          </Grid>
          
          <Grid item xs={12}>
            <FieldLabel text="Parametry" />
            <TextField
              fullWidth
              name="parameters"
              value={formData.parameters}
              onChange={handleChange}
              multiline
              minRows={10}
              maxRows={15}
              variant="outlined"
              size="small"
              placeholder="Wpisz parametry"
              sx={{ 
                ...textFieldSx, 
                '& .MuiOutlinedInput-root': { height: 'auto', backgroundColor: '#fff', borderRadius: '4px', alignItems: 'flex-start' },
                '& .MuiInputBase-input': { padding: 0 },
                '& .MuiOutlinedInput-input': { padding: 0 }
              }}
            />
          </Grid>
          
          <Grid item xs={12}>
            <FieldLabel text="Szacowana wartość" />
            <TextField
              fullWidth
              name="estimatedValue"
              type="number"
              value={formData.estimatedValue}
              onChange={handleChange}
              variant="outlined"
              size="small"
              placeholder="np. 1500000,00"
              sx={textFieldSx}
              InputProps={{
                endAdornment: <InputAdornment position="end">PLN</InputAdornment>,
              }}
            />
          </Grid>
        </Grid>
        )}
        </Box>
        <Divider />
        <Box sx={{ px: 4, py: 2, display: 'flex', justifyContent: 'space-between', boxShadow: '0px 4px 4px rgba(0,0,0,0.05)' }}>
          <Box>
            {editMode && onDelete && (
              <Button 
                onClick={handleDelete} 
                variant="outlined" 
                color="error"
                sx={{
                  fontFamily: 'Roboto, sans-serif',
                  fontSize: '14px',
                  textTransform: 'none'
                }}
              >
                Usuń pakiet
              </Button>
            )}
          </Box>
          <Box>
            <Button 
              onClick={onClose} 
              variant="text"
              sx={{
                fontFamily: 'Roboto, sans-serif',
                fontSize: '14px',
                textTransform: 'none',
                color: '#2D2D32',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)'
                }
              }}
            >
              Anuluj
            </Button>
            <Button 
              onClick={handleSubmit} 
              variant="contained" 
              disabled={useCustomWorkType ? !(selectedStage && customWorkName.trim()) : (!editMode && !selectedPackage)}
              sx={{ 
                backgroundColor: '#020242',
                fontFamily: 'Roboto, sans-serif',
                fontSize: '14px',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: '#030360'
                },
                '&:disabled': {
                  backgroundColor: 'rgba(0, 0, 0, 0.12)',
                  color: 'rgba(0, 0, 0, 0.26)'
                }
              }}
            >
              {editMode ? 'Zapisz zmiany' : 'Dodaj pakiet'}
            </Button>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default AddPackageForm;
